import React from 'react';
import { useNavigate } from 'react-router-dom';
import './../styles/Buttons/BackButton.css';

export default function BackButton({ label = '← Back', fallback = '/' }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };

  return (
    <button className="back-button" onClick={handleBack}>
      {label}
    </button>
  );
}
